(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["banner-uitblinker"] && !Shopify.designMode) return;
  try {
    // Demo month tabs: group the demo-mode instances per section under one
  // generated tablist and show one instance at a time. Months without an
  // entry (data-ub-demo-empty) get no tab and stay hidden.
  function ubBuildDemoTabs(scope) {
    const sections = new Set();
    (scope || document).querySelectorAll('.ub-demo-instance').forEach((el) => {
      sections.add(el.closest('.shopify-section') || document.body);
    });
    sections.forEach((section) => {
      section.querySelectorAll('.ub-demo-tabs').forEach((el) => el.remove());
      const all = [...section.querySelectorAll('.ub-demo-instance')];
      const instances = all.filter((el) => !el.hasAttribute('data-ub-demo-empty'));
      all.forEach((el) => {
        el.hidden = true;
      });
      if (!instances.length) return;
      const tablist = document.createElement('div');
      tablist.className = 'ub-demo-tabs';
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Uitblinkers per maand');
      instances.forEach((inst, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'promotional-banner-demo__tab';
        btn.classList.toggle('promotional-banner-demo__tab--active', i === 0);
        btn.textContent = inst.dataset.ubDemoLabel || '';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.tabIndex = i === 0 ? 0 : -1;
        btn.addEventListener('click', () => {
          instances.forEach((other) => {
            other.hidden = other !== inst;
          });
          tablist.querySelectorAll('[role="tab"]').forEach((b) => {
            const active = b === btn;
            b.classList.toggle('promotional-banner-demo__tab--active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
            b.tabIndex = active ? 0 : -1;
          });
        });
        tablist.append(btn);
      });
      instances[0].hidden = false;
      instances[0].parentElement.insertBefore(tablist, all[0]);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const tab = event.target.closest('.ub-demo-tabs [role="tab"]');
    if (!tab) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
    next.focus();
    next.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ubBuildDemoTabs());
  } else {
    ubBuildDemoTabs();
  }
  document.addEventListener('shopify:section:load', (event) => ubBuildDemoTabs(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["banner"] && !Shopify.designMode) return;
  try {
    // Demo-mode month tabs: delegated so it works for every banner block on the
  // page with one listener pair.
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pb-demo-tab]');
    if (!tab) return;
    const container = tab.closest('.promotional-banner-demo-months');
    if (!container) return;
    container.querySelectorAll('[data-pb-demo-tab]').forEach((t) => {
      const active = t === tab;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;
      t.classList.toggle('promotional-banner-demo__tab--active', active);
    });
    container.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
  });

  // Demo switch groups: one listener per group type, delegated like the tabs.
  function activateSwitchButton(container, selector, btn) {
    container.querySelectorAll(selector).forEach((b) => {
      const active = b === btn;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.classList.toggle('promotional-banner-demo__switch-btn--active', active);
    });
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pb-demo-variant]');
    if (!btn) return;
    const container = btn.closest('.promotional-banner-demo-months');
    if (!container) return;
    activateSwitchButton(container, '[data-pb-demo-variant]', btn);
    container.setAttribute('data-variant-filter', btn.dataset.pbDemoVariant);
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pb-demo-format]');
    if (!btn) return;
    const container = btn.closest('.promotional-banner-demo-months');
    if (!container) return;
    activateSwitchButton(container, '[data-pb-demo-format]', btn);
    const format = btn.dataset.pbDemoFormat;
    container.toggleAttribute('data-newsletter-filter', format === 'nieuwsbrief');
    container.toggleAttribute('data-followup-filter', format === 'vervolgpagina');
    // The variant and ratio switches only affect the website view.
    container.querySelectorAll('[data-pb-demo-variant], [data-pb-demo-ratio]').forEach((b) => {
      b.disabled = format !== 'website';
    });
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-pb-demo-ratio]');
    if (!btn) return;
    const container = btn.closest('.promotional-banner-demo-months');
    if (!container) return;
    activateSwitchButton(container, '[data-pb-demo-ratio]', btn);
    // Only blok-format cards follow the ratio; newsletter cards are fixed-size
    // and strook cards use the leaderboard layout.
    container
      .querySelectorAll('.promotional-banner-demo--blok > .promotional-banner:not(.promotional-banner--newsletter)')
      .forEach((card) => {
        card.style.setProperty('--pb-aspect-ratio', btn.dataset.pbDemoRatio);
      });
  });

  // Demo-mode collection lists: each collection goes to the month panel that
  // holds its data-middle.
  function pbLoadDemoCollections(scope) {
    scope.querySelectorAll('[data-pb-demo-collections-url]').forEach(async (container) => {
      const { pbDemoCollectionsUrl: url, pbDemoCollectionPages: pages } = container.dataset;
      const responses = await Promise.all(
        Array.from({ length: Number(pages) }, (_, i) => fetch(`${url}&page=${i + 1}`).then((r) => r.text()))
      );
      const items = document.createElement('template');
      items.innerHTML = responses.join('');
      const lists = [...container.querySelectorAll('.promotional-banner-demo__collections')];
      [...items.content.querySelectorAll('tr')]
        .sort((a, b) => a.dataset.middle - b.dataset.middle)
        .forEach((item) => {
          const middle = Number(item.dataset.middle);
          const list = lists.find(
            (el) => middle >= Number(el.dataset.monthStart) && middle <= Number(el.dataset.monthEnd)
          );
          if (!list) return;
          list.querySelector('tbody').append(item);
          list.hidden = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => pbLoadDemoCollections(document));
  } else {
    pbLoadDemoCollections(document);
  }
  document.addEventListener('shopify:section:load', (event) => pbLoadDemoCollections(event.target));

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const tab = event.target.closest('[data-pb-demo-tab]');
    if (!tab) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-pb-demo-tab]')];
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const next = tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
    next.focus();
    next.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    // Shopify keeps only the last contact[tags] field, so the checked tags go out as one comma-separated value
  class NewsletterTags extends HTMLElement {
    connectedCallback() {
      this.closest('form')?.addEventListener('formdata', ({ formData }) => {
        const tags = formData.getAll('contact[tags]');

        if (tags.length > 1) formData.set('contact[tags]', tags.join(','));
      });
    }
  }

  if (!customElements.get('newsletter-tags')) customElements.define('newsletter-tags', NewsletterTags);

  // With a newsletter page set, the visitor picks their newsletters there instead of subscribing here.
  // The capture phase runs before any other submit handler can send the form. The address travels through
  // sessionStorage, so it never appears in a URL that analytics or ad pixels record.
  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.dataset.newsletterPage) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        sessionStorage.setItem(
          'newsletter-signup:email',
          String(new FormData(form).get('contact[email]') ?? '').trim(),
        );
      } catch {}

      window.location.assign(form.dataset.newsletterPage);
    },
    true,
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nn-reviews-form"] && !Shopify.designMode) return;
  try {
    class NNReviewFormComponent extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-review-form]');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[data-submit-button]');
      this.submitLabel = this.submitButton.textContent;
      this.messageEl = this.form.querySelector('[data-message]');
      this.variantIdInput = this.form.querySelector('[data-variant-id]');
      this.ratingGroup = this.form.querySelector('[data-rating-group]');

      this.form.addEventListener('submit', this.#handleSubmit.bind(this));

      this.form.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
          e.preventDefault();
          this.form.requestSubmit();
        }
      });

      // Update variant ID when dialog opens
      this.addEventListener('dialog:open', () => {
        this.#updateVariantId();
      });
    }

    #detectCurrentVariant() {
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('[name="id"]');
        if (variantInput && variantInput.value) {
          return 'gid://shopify/ProductVariant/' + variantInput.value;
        }
      }
      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');
      if (variantParam) {
        return 'gid://shopify/ProductVariant/' + variantParam;
      }
      return '';
    }

    #updateVariantId() {
      if (this.variantIdInput) {
        this.variantIdInput.value = this.#detectCurrentVariant();
      }
    }

    #showMessage(text, isSuccess) {
      this.messageEl.textContent = text;
      this.messageEl.className = 'nn-review-form__message';
      this.messageEl.classList.add(isSuccess ? 'nn-review-form__message--success' : 'nn-review-form__message--error');
      this.messageEl.setAttribute('role', isSuccess ? 'status' : 'alert');
      this.messageEl.setAttribute('aria-live', isSuccess ? 'polite' : 'assertive');
      this.messageEl.hidden = false;
    }

    async #handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();

      if (!this.form.checkValidity()) {
        const firstInvalid = this.form.querySelector(':invalid');
        if (firstInvalid) {
          const isHiddenRadio = firstInvalid.matches('[data-rating]');
          const target = isHiddenRadio ? this.ratingGroup : firstInvalid;
          target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (!isHiddenRadio) firstInvalid.focus({ preventScroll: true });
        }
        return;
      }

      this.submitButton.disabled = true;
      this.submitButton.textContent = this.form.dataset.submitting;
      this.messageEl.hidden = true;

      try {
        const formData = new FormData(this.form);
        const response = await fetch('/apps/nn_reviews/submit', {
          method: 'POST',
          body: formData,
        });

        const result = await response.json();

        if (response.ok && result.success) {
          this.#showMessage(result.message || this.form.dataset.success, true);
          this.form.reset();

          // Close dialog after success
          setTimeout(() => {
            const dialogComponent = this.closest('dialog-component');
            if (dialogComponent && typeof dialogComponent.closeDialog === 'function') {
              dialogComponent.closeDialog();
            }
          }, 2000);
        } else {
          this.#showMessage(result.error || this.form.dataset.error, false);
        }
      } catch (error) {
        this.#showMessage(this.form.dataset.error, false);
      } finally {
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.submitLabel;
      }
    }
  }

  if (!customElements.get('nn-review-form')) {
    customElements.define('nn-review-form', NNReviewFormComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
